var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76465 2.7168L2.63867 4.32324L3.53711 2.7168H5.03613L3.54199 5.2998L5.10449 8H3.60059L2.64844 6.30078L1.69629 8H0.192383L1.75488 5.2998L0.260742 2.7168H1.76465ZM10.5244 6.90137V8H5.66113V7.0625L7.96094 4.59668C8.19206 4.33952 8.37435 4.11328 8.50781 3.91797C8.64128 3.7194 8.7373 3.54199 8.7959 3.38574C8.85775 3.22624 8.88867 3.07487 8.88867 2.93164C8.88867 2.7168 8.85286 2.53288 8.78125 2.37988C8.70964 2.22363 8.60384 2.10319 8.46387 2.01855C8.32715 1.93392 8.15788 1.8916 7.95605 1.8916C7.74121 1.8916 7.55566 1.94368 7.39941 2.04785C7.24642 2.15202 7.12923 2.29688 7.04785 2.48242C6.96973 2.66797 6.93066 2.87793 6.93066 3.1123H5.51953C5.51953 2.68913 5.62044 2.30176 5.82227 1.9502C6.02409 1.59538 6.30892 1.3138 6.67676 1.10547C7.0446 0.89388 7.48079 0.788086 7.98535 0.788086C8.4834 0.788086 8.90332 0.869466 9.24512 1.03223C9.59017 1.19173 9.85059 1.42285 10.0264 1.72559C10.2054 2.02507 10.2949 2.38314 10.2949 2.7998C10.2949 3.03418 10.2575 3.26367 10.1826 3.48828C10.1077 3.70964 10.0003 3.93099 9.86035 4.15234C9.72363 4.37044 9.55762 4.5918 9.3623 4.81641C9.16699 5.04102 8.95052 5.27376 8.71289 5.51465L7.47754 6.90137H10.5244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX2);
export default __webpack_public_path__ + "static/media/x2.31133c1757b6d32bdb834160ed659385.svg";
export { ForwardRef as ReactComponent };